var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.9983V19.9983H3V17.9983H21ZM6.596 3.90234L8.01 5.31634L4.828 8.49834L8.01 11.6803L6.596 13.0943L2 8.49834L6.596 3.90234ZM21 10.9983V12.9983H12V10.9983H21ZM21 3.99834V5.99834H12V3.99834H21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuExtend);
export default __webpack_public_path__ + "static/media/icon_menu_extend.5f924d4e75191578436eb9770f3f9975.svg";
export { ForwardRef as ReactComponent };